export const Autocomplete = theme => {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[20],
        },
      },
    },
  }
}
